import { render } from "./shop_sells_trends_aggr.vue?vue&type=template&id=46b3338c&scoped=true"
import script from "./shop_sells_trends_aggr.vue?vue&type=script&lang=js"
export * from "./shop_sells_trends_aggr.vue?vue&type=script&lang=js"

import "./shop_sells_trends_aggr.vue?vue&type=style&index=0&id=46b3338c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46b3338c"]])

export default __exports__